<!-- <div class="modal-dialog"> -->
    <div class="modal-content">

        <div class="modal-header">
            <h4 class="modal-title txt-enter-credential" id="myCenterModalLabel">{{options.header || ('LABELS.PAYEX_PRIVATE_LIMITED' | translate)}} </h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  (click)="closeCrossButton()"></button>
        </div>
    
        <div class="modal-body">
            <div class="justify-content-center">
                <!-- <div class="icon-container" *ngIf="!options.icons && options.icon"> -->
                <div class="row" *ngIf="!options.icons && options.icon">
                    <div class="col-12">
                        <div class="form-group mb-3 d-flex justify-content-center">
                            <!-- <ion-icon class="custom-icon" name="{{options.icon.icon}}" [style.color]="options.icon.color"></ion-icon> -->
                            <i class="custom-icon" [style.color]="options.icon.color" [ngClass]="options.icon.icon"></i>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div class="icon-container" *ngIf="options.icons"> -->
                <div class="row" *ngIf="options.icons">
                    <div class="col-12">
                        <div class="form-group mb-3 d-flex justify-content-center">
                            <ion-icon *ngFor="let icon of options.icons" class="custom-icon-multi font-size5rm" name="{{icon.icon}}"
                                [style.color]="icon.color"></ion-icon>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div class="headerContent" [innerHtml]="options.header" *ngIf="options.header"></div> -->
                <p class="dialogContent" [innerHtml]="options.html"></p>
            </div>
        </div>
    
         <!-- footer -->
        <div class="modal-footer" *ngIf="options.buttons.length">
            <div class="grid-structure width100">
                <div class="width100 d-flex" *ngIf="options.buttons.length > 1">
                    <div class="width50 text-center" *ngFor="let btn of options.buttons">
                        <button type="button" expand="block" class="btn  fis-btn waves-effect width70"
                            (click)="close(btn)">{{btn.btnText}}
                        </button>
                    </div>
                </div>
                <div class="width100 d-flex" *ngIf="options.buttons.length === 1">
                    <div class="width100 button-list text-center" *ngFor="let btn of options.buttons">
                        <button type="button" expand="block" class="btn  fis-btn waves-effect width70"
                            (click)="close(btn)">{{btn.btnText}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    
    <!-- </div> -->